import { useEffect, useState } from 'react';
import { GetInvitedUsersResponseType } from 'app/organizations-api/user/user';
import { organizationsApi, GetResponseType } from 'app/organizations-api/types';

export const useGetInvitedUsers = (page?: number, pageSize?: number) => {
  const [getInvitedUsersResponse, setInvitedUsersResponse] = useState<
    GetResponseType<GetInvitedUsersResponseType>
  >({
    data: null,
    loading: false,
    error: null
  });

  const fetchInvitedUsers = async (page?: number, pageSize?: number) => {
    const response = await organizationsApi.getInvitedUsers(page, pageSize);
    setInvitedUsersResponse(response);
  };

  useEffect(() => {
    fetchInvitedUsers(page, pageSize);
  }, []);

  const refetch = (page?: number, pageSize?: number) => fetchInvitedUsers(page, pageSize);

  return {
    data: getInvitedUsersResponse.data,
    httpCode: getInvitedUsersResponse.httpCode,
    error: getInvitedUsersResponse.error,
    loading: getInvitedUsersResponse.loading,
    refetch: refetch
  };
};
